export default "__VITE_ASSET__CFepLS7___"